import { ElementTypes } from "@archetypes/form";
import { ARITHMETIC_OPERATOR, RelationalOperators } from "@archetypes/operator";
import * as z from "zod";

export const FormSettingSchema = z.object({
  formName: z.string().min(1),
  formDescription: z.string().optional(),
  coverImage: z.string().optional(),
  showQuestionNo: z.boolean().optional(),
  enableCaptcha: z.boolean().optional(),
  disableFormAfterMaxSubmissions: z.number().optional(),
  publishOn: z.date().optional(),
  unpublishOn: z.date().optional(),
  enableScoring: z.boolean().optional(),
  submitButtonText: z.string(),
  sendCopyOfResponse: z.boolean(),
  removeBranding: z.boolean(),
  scoring: z
    .object({
      initialScore: z.number(),
      fieldsets: z.array(
        z.object({
          questionId: z.string(),
          relationalOperator: z.enum(RelationalOperators),
          arithmeticOperator: z.enum([
            ARITHMETIC_OPERATOR.ADDITION,
            ARITHMETIC_OPERATOR.SUBSTRACTION,
            ARITHMETIC_OPERATOR.MULTIPLICATION,
            ARITHMETIC_OPERATOR.DIVISION,
          ]),
          questionType: z.enum(ElementTypes),
          answer: z.any().optional(),
          score: z.number(),
        }),
      ),
    })
    .optional(),
  resetFormAfterSubmit: z.boolean(),
  compositeFields: z.array(z.string()).optional(),
});

export type FormSettingsData = z.infer<typeof FormSettingSchema>;
